import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static values = { url: String }

  goTo(event) {
    if (event.target.tagName !== "A" && event.target.tagName !== "BUTTON") {
      Turbo.visit(this.urlValue)
    }
  }
}
